module.exports = __webpack_public_path__ + "static/media/selfie.fe69f952.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/selfie.svg
// module id = 303
// module chunks = 0